import { create } from "zustand";
import { Order, OrderSearchParams, OrderSummary } from "../../types";
interface OrderState<T> {
  orders: Record<string, T>;
  setOrders: (orders: Record<string, T>) => void;
  loading: boolean;
  ordersLoaded: boolean;
  setOrdersLoaded: (loaded: boolean) => void;
}

const generateOrderSet = <T>({ordersLoadedInitial = false} = {}) => (set: any) => ({
  orders: {},
  loading: true,
  setOrders: (orders: Record<string, T>) => set({ orders, loading: false }),
  ordersLoaded: ordersLoadedInitial,
  setOrdersLoaded: (ordersLoaded: boolean) => set({ ordersLoaded }),
})

export const useOrders = create<OrderState<Order>>(generateOrderSet<Order>());
export const useOrderHistory = create<OrderState<OrderSummary>>(generateOrderSet<OrderSummary>({ordersLoadedInitial: true}));


interface OrderSearchParamsState {
  orderSearchParams: OrderSearchParams | null;
  setOrderSearchParams: (orderSearchParams: OrderSearchParams) => void;
  activePage: number;
  setActivePage: (activePage: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  noHistorySearchCriteria: boolean;
  setNoHistorySearchCriteria: (noHistorySearchCriteria: boolean) => void;
}

const orderSearchParamsStateSet = (set: any) => ({
  orderSearchParams: null,
  setOrderSearchParams: (orderSearchParams: OrderSearchParams) => set({ orderSearchParams }),
  activePage: 1,
  setActivePage: (activePage: number) => set({ activePage }),
  pageSize: 10,
  setPageSize: (pageSize: number) => set({ pageSize }),
  noHistorySearchCriteria: true,
  setNoHistorySearchCriteria: (noHistorySearchCriteria: boolean) => set({ noHistorySearchCriteria }),
});

export const useOrderSearchParams = create<OrderSearchParamsState>(orderSearchParamsStateSet);